module.exports = __webpack_public_path__ + "static/img/xt-en.d485f7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/XT/xt-en.png
// module id = S9yt
// module chunks = 0